var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-block",on:{"click":_vm.bannerClick}},[_c('iframe',{attrs:{"src":"https://api.itender.am/banner/","height":"300","width":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }